import { format } from "date-fns";
import en from "date-fns/locale/en-US";
import ja from "date-fns/locale/ja";
import { useI18n } from "hooks/i18n/i18n";

const MONTHS_BASE = Array.from({ length: 12 });

export const useGetMonths = () => {
  const { i18n } = useI18n();
  const isJaLocale = i18n.language === "ja";
  const formatString = isJaLocale ? "M月" : "MMM";
  const locale = isJaLocale ? ja : en;

  return MONTHS_BASE.map((_, index) => {
    // 12ヶ月分の翻訳を date-fns に任せるため無理やり日付を生成してるため、年・日の値は重要じゃない
    const targetDate = new Date(2025, index, 1);
    return format(targetDate, formatString, { locale });
  });
};
